export function countImagesPerCategory(images: MediaInfoDto[]): number[] {
  const totalImagesPerCategory = [];
  images.forEach(image => {
    if (!totalImagesPerCategory[image.imageCategory]) {
      totalImagesPerCategory[image.imageCategory] = 1;
    } else {
      totalImagesPerCategory[image.imageCategory] += 1;
    }
  });
  return totalImagesPerCategory;
}

export function ucsIsNil(object: any) {
  //check null and undefined for better understandability
  //check is equal to object == null
  return object === null || object === undefined;
}

export function ucsDeepEqual(obj1: any, obj2: any): boolean {
  if (typeof obj1 !== 'object' || typeof obj2 !== 'object' || obj1 === null || obj2 === null) {
    // Handle primitive values and nulls
    return obj1 === obj2;
  }

  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) {
    // If the number of keys is different, objects are not equal
    return false;
  }

  for (const key of keys1) {
    if (!keys2.includes(key)) {
      // Check if the key exists in both objects
      return false;
    }

    if (!ucsDeepEqual(obj1[key], obj2[key])) {
      // Recursive check for nested objects
      return false;
    }
  }

  return true;

}

export function compareSets(setA: any[], setB: any[]): boolean {
  return setA?.length === setB?.length && setA.every((value) => setB.includes(value));
}

export function addPrices(priceA: PriceDto, priceB: PriceDto): PriceDto {
  if (priceA?.currency.text === priceB?.currency.text) {
    const result: PriceDto = structuredClone(priceA);
    result.net += priceB.net;
    result.gross += priceB.gross;

    return result;
  }
  return undefined;
}

export function subtractPrices(priceA: PriceDto, priceB: PriceDto): PriceDto {
  if (priceA?.currency.text === priceB?.currency.text) {
    const result: PriceDto = structuredClone(priceA);
    result.net -= priceB.net;
    result.gross -= priceB.gross;

    return result;
  }
  return undefined;
}
